export const FILE_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  IN_PROCESS: "IN_PROCESS",
  PROCESSED: "PROCESSED",
  UPLOADED: "UPLOADED",
};

export const OPERATION_TYPE = {
  EXPORT: "EXPORT",
  IMPORT: "IMPORT",
  ALL: "ALL",
};

export const CONTEXT_TYPE = [
  { key: "LEADERBOARDS", text: "Export leaderboard" },
  {
    key: "LEADERBOARDS_MODIFY_REWARD_RANKS",
    text: "Leaderboards modify rank entries",
  },
  { key: "LEADERBOARDS_REMOVE_USERS", text: "Leaderboards remove users" },
  { key: "CONSUMER_REWARD", text: "Export consumer reward" },
  { key: "CODE_GROUP", text: "Code group" },
  { key: "INSTANT_WIN_IMPORT_PRIZE_SEED_DATA", text: "Instant win import moments" },
  { key: "INSTANTWIN_PRIZE_SEED", text: "Export instant win moments" },
  { key: "CONSUMER_REWARD_STATUS_UPDATES", text: "Consumer reward status updates" },
  {
    key: "SWEEPSTAKES_MANUAL_WINNER_SELECTION",
    text: "Sweepstakes manual winner selection",
  },
  { key: "SWEEPSTAKE_ENTRIES", text: "Export sweepstakes entries" },
  { key: "PLATFORM_SEGMENTS", text: "Platform segments" },
  { key: "USERS_BY_SEGMENT", text: "Export users by segment" },
  { key: "USER_PROFILE", text: "Export users" },
  { key: "FULFILLMENT_ORDER", text: "Export fulfillment orders" },
  { key: "USERS_PERFORMANCES", text: "Export user performances" },
  { key: "RECEIPT_SCAN_PERFORMANCES", text: "Export receipt scan performances" },
];

export const STATUS_COLORS = {
  PENDING: "#0066CC",
  PROCESSING: "#FFA500",
  COMPLETED: "#28A745",
  FAILED: "#DC3545",
  EXPIRED: "#6C757D",
  IN_PROCESS: "#FFA500",
  PROCESSED: "#28A745",
  UPLOADED: "#0066CC",
};

export const STATUS_LABELS = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
  EXPIRED: "Expired",
  IN_PROCESS: "In Process",
  PROCESSED: "Processed",
  UPLOADED: "Uploaded",
};

export const POLLING_INTERVAL = 30000;
export const ITEMS_PER_PAGE = 20;
export const MAX_FILENAME_LENGTH = 40;
